import { Heading, Loader, Text } from '@afterpaytouch/core'
import React, { FunctionComponent, ReactNode } from 'react'

import styles from './styles.module.css'

interface Props {
  title?: string
  description?: string | ReactNode
  show?: boolean
}

export const PostCaptureHeader: FunctionComponent<Props> = ({ title = '', description = '', show = false }) => {
  if (!show || (!title && !description)) {
    return null
  }

  return (
    <div className={styles.confirmHeader}>
      <div className={styles.checkmarkLoader}>
        <Loader loaderKind='Checkmark' />
      </div>
      {title && (
        <div className={styles.confirmHeaderPrimaryTitle}>
          <Heading size='XXL' bold>
            {title}
          </Heading>
        </div>
      )}
      {description && (
        <div className={styles.confirmHeaderDescription}>
          <Text role='textbox' size='M'>
            {description}
          </Text>
        </div>
      )}
    </div>
  )
}
